import { fg } from '@atlaskit/platform-feature-flags/fg';

/**
 * Shared by the capability and the stream handling so they can't drift apart. Typed
 * parts render through inline Lumina slots, so they also need inline Lumina;
 * `rovo_chat_answer_ui_parts` keeps their rollout and kill switch separate.
 */
export const isAnswerUiPartsEnabled = (): boolean =>
	fg('rovo_chat_enable_inline_lumina') && fg('rovo_chat_answer_ui_parts');
